import React, { forwardRef } from "react";
import styled from "styled-components";
import { HiddenCheckbox } from "./Checkbox";
import { Box } from "./Box";
const StyledToggle = styled(Box)(({ theme: { colors: { toggleColors, inputColors }, borders, radii, shadows, sizes, }, }) => ({
    [`${HiddenCheckbox}:checked + &:after`]: {
        left: "17px",
    },
    [`${HiddenCheckbox}:checked + &`]: {
        background: toggleColors.checked,
        borderColor: toggleColors.checked,
    },
    [`${HiddenCheckbox}:disabled + &`]: {
        background: toggleColors.disabled,
        borderColor: toggleColors.disabled,
        cursor: "not-allowed",
    },
    [`${HiddenCheckbox}[readonly] + &`]: {
        background: toggleColors.disabled,
        borderColor: toggleColors.disabled,
        cursor: "not-allowed",
        pointerEvents: "none",
    },
    [`${HiddenCheckbox}:focus + &`]: {
        borderColor: inputColors.inputFocusBorder,
        boxShadow: shadows.searchBox.contentShadow,
    },
    "&:after": {
        background: "white",
        borderRadius: radii[2],
        content: "''",
        height: `${sizes[3]}px`,
        left: "1px",
        position: "absolute",
        top: "1px",
        transition: "all 250ms",
        width: `${sizes[3]}px`,
    },
    background: toggleColors.background,
    border: `${borders[1]} ${toggleColors.background}`,
    borderRadius: radii[2],
    cursor: "pointer",
    display: "block",
    height: "20px",
    position: "relative",
    transition: "all 250ms",
    width: "36px",
}));
/**
 * Represents a state which is either enabled or disabled. The control should
 * be used with the state controlled by hosting component.
 */
export const Toggle = forwardRef(({ value, checked, disabled, name = "toggle", "data-testid": testId = "Toggle", onBlur, onChange, onClick, readOnly, }, ref) => (
// Margin is set to zero to prevent additional margin added by Classic Styles.
React.createElement(Box, { as: "label", onClick: onClick, margin: "0" },
    React.createElement(HiddenCheckbox, { "data-testid": testId, onBlur: onBlur, onChange: onChange, disabled: disabled, checked: checked, value: value, name: name, ref: ref, readOnly: readOnly }),
    React.createElement(StyledToggle, null))));
